export default __webpack_public_path__ + "static/media/info.b2af75d3.svg";